/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function BarsIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M6 10c0-.812.625-1.5 1.5-1.5h25c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-25c-.875 0-1.5-.625-1.5-1.5m0 10c0-.812.625-1.5 1.5-1.5h25c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-25c-.875 0-1.5-.625-1.5-1.5m28 10c0 .875-.687 1.5-1.5 1.5h-25c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5h25c.813 0 1.5.688 1.5 1.5"/>}
        </IconWrapper>);
}
